let audioCtx: AudioContext | null = null;
let unlocked = false;

function getAudioContext(): AudioContext | null {
  if (typeof window === 'undefined') return null;
  const Ctor = window.AudioContext || (window as Window & { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
  if (!Ctor) return null;
  if (!audioCtx) audioCtx = new Ctor();
  return audioCtx;
}

function unlockAudio() {
  if (unlocked) return;
  const ctx = getAudioContext();
  if (!ctx) return;
  void ctx.resume().then(() => {
    unlocked = ctx.state === 'running';
  });
}

if (typeof window !== 'undefined') {
  const onFirstGesture = () => {
    unlockAudio();
    window.removeEventListener('pointerdown', onFirstGesture);
    window.removeEventListener('keydown', onFirstGesture);
  };
  window.addEventListener('pointerdown', onFirstGesture);
  window.addEventListener('keydown', onFirstGesture);
}

function playTone(ctx: AudioContext, frequency: number, start: number, duration: number) {
  const oscillator = ctx.createOscillator();
  const gain = ctx.createGain();
  oscillator.type = 'sine';
  oscillator.frequency.value = frequency;
  gain.gain.setValueAtTime(0, start);
  gain.gain.linearRampToValueAtTime(0.07, start + 0.02);
  gain.gain.exponentialRampToValueAtTime(0.001, start + duration);
  oscillator.connect(gain);
  gain.connect(ctx.destination);
  oscillator.start(start);
  oscillator.stop(start + duration + 0.02);
}

/** Короткий звук вместе с тостом о новом сообщении. */
export function playSupportChatIncomingSound() {
  const ctx = getAudioContext();
  if (!ctx) return;
  void ctx.resume().then(() => {
    const t0 = ctx.currentTime;
    playTone(ctx, 880, t0, 0.12);
    playTone(ctx, 1175, t0 + 0.11, 0.16);
  });
}
